import  React from "react";
import { useTranslation } from "react-i18next";


export default function Footer() {
 
  const [t,i18n] = useTranslation("global"); 
  
  console.log(i18n.language)

  return (
        
      <div className="lg:flex justify-center text-black font-dmSans bg-[#F6FAFD] px-10 py-10 5xl:h-[1200px] min-h-[306px]  4xl:min-h-[460px]">
          {/* Left Side */}
      <div className="bg-white rounded-[8px] lg:w-96 max-h-[200px] lg:mr-5 p-8 border-2 pb-30">
          <div className="flex"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg><p className="text-[22px] text-left ml-2">TSS</p><div className="w-4 h-4 -ml-[61px] rounded-full bg-[#A15842] opacity-25"> </div>  <div className="w-14 h-[5px] bg-[#A15842] ml-48 opacity-25 mt-5"></div></div>
          
          <p className="text-left text-[14px] mt-5">{t("footer.tss-desc")}</p>
          
          </div>  

          <div className="bg-white rounded-[8px] lg:w-96 max-h-[200px] p-8 border-2 mt-5 lg:mt-0 pb-30">
          <div className="flex"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.5 12H16c-.7 2-2 3-4 3s-3.3-1-4-3H2.5"/><path d="M5.5 5.1L2 12v6c0 1.1.9 2 2 2h16a2 2 0 002-2v-6l-3.4-6.9A2 2 0 0016.8 4H7.2a2 2 0 00-1.8 1.1z"/></svg>  <p className="text-[22px] text-left ml-2">ISR</p><div className="w-4 h-4 -ml-[55px] rounded-full bg-[#3EC1F3] opacity-25"> </div>  <div className="w-14 h-[5px] bg-[#3EC1F3] ml-48 opacity-25 mt-5"></div></div>
          <p className="text-left text-[14px] mt-5">{t("footer.isr-desc")}</p>
          </div>    
      
      </div>
   
  );
}